import problemStore from "../problemStore";

const getProblemForCurrentURL = (params) => {
  const { problemUrl } = params;
  const problemFiltered = problemStore.filter((e) => e.url === problemUrl)[0];
  return problemFiltered;
};

export default getProblemForCurrentURL;
